import { render, staticRenderFns } from "./CardTemplateMarket.vue?vue&type=template&id=6ca97324&scoped=true&"
import script from "./CardTemplateMarket.vue?vue&type=script&lang=js&"
export * from "./CardTemplateMarket.vue?vue&type=script&lang=js&"
import style0 from "./CardTemplateMarket.vue?vue&type=style&index=0&id=6ca97324&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca97324",
  null
  
)

component.options.__file = "CardTemplateMarket.vue"
export default component.exports